import React from 'react';
import AdminQuizPage from '../../body/AdminQuizPage';
import { pdfFiles } from '../../body/Pdf';
import { ADMIN_QUIZ_MODULES } from '../../../../apis/quiz';

const introPdf = pdfFiles.introduction[0];

const Mod1Quiz = () => (
  <AdminQuizPage
    moduleKey={ADMIN_QUIZ_MODULES.introduction}
    pdfSrc={introPdf.url}
    pdfText={introPdf.name}
  />
);

export default Mod1Quiz;

